

























import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import { isObjectValueEqual } from '@/utils/urlUtils'
import { setTitle } from './../model/api'

@Component
export default class PaperHead extends Vue {
  @Prop({ default: 'question' }) home!: string
  @Prop({
    default() {
      return 1
    }
  })
  usage!: number | string

  public title = ''
  public data = []
  public outline = false
  // computed
  public get cartInfo() {
    return this.$store.state.question.cart
  }
  public get subjectId() {
    return this.$store.state.subject.value
  }
  /**
   * mounted
   */
  public mounted() {
    this.title = this.cartInfo.title
    this.getData()
  }
  @Watch('cartInfo', { deep: true })
  onCartChange(val, old) {
    if (isObjectValueEqual(val, old)) return
    // console.log(this.title)
    this.getData()
  }
  public getFocus() {
    this.outline = true
  }
  public removeFocus() {
    this.outline = false
    this.title = this.title && this.title.replace(/\s+/g, '') // 去除空格
    this.setPaperTitle()
  }
  public submit() {
    // eslint-disable-next-line no-extra-semi
    ;(this.$refs as any).paper_title.blur()
  }
  public async setPaperTitle() {
    let params: any = {
      title: this.title,
      subject_id: this.subjectId
    }
    if (!this.title) {
      this.title = this.cartInfo.title
      return
    }
    
    params.usage = this.usage
    let data: any = await setTitle(params)
    // console.log(data)
    if (data.success) {
      this.$store.commit('SET_CART', data.data)
    } else {
      this.$message.warning(data.error)
      this.title = this.cartInfo.title
    }
  }
  public getData() {
    let temp: any = []
    for (let n in this.cartInfo.classification) {
      temp = [
        ...temp,
        {
          name: this.cartInfo.classification[n].business_type,
          val: this.cartInfo.classification[n].sequence
        }
      ]
    }
    // console.log(temp)
    this.data = temp
  }
}
